<template lang="pug">
.uiInputComponent
  input.input(
    v-bind="$attrs"
    type="text"
    :class="{_error: v$.$error}"
    :value="modelValue"
    @input="$emit('update:modelValue', $event.target.value)"
  )
  .error(
    v-for="error in v$.$errors"
    :key="error.$validator"
  ) {{ errors[error.$validator] }}
</template>

<script>
export default {
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    v$: {
      type: Object,
      default: () => {}
    },
    errors: {
      type: Object,
      default: () => {}
    }
  },
  emits: ['update:modelValue'],
  setup () {}
}
</script>

<style lang="sass" scoped>
.uiInputComponent
  .input
    @include font('t16-medium')
    padding: 1.5*$u 3*$u
    border-radius: 2.5*$u
    color: $cText
    border-width: 0.75*$u
    border-style: solid
    border-color: $cDarkBackground
    width: 100%
    transition: $animationSpeed
    &:hover
      border-color: $cBlue
    &:focus
      border-color: $cDarkBlue

    &._error
      border-color: $cOrange

  .error
    @include font('t14-regular')
    color: $cOrange
    margin-top: $u
</style>
